/**
 * Custom cursor
 */

class CustomCursor {

    hoverContainers = null;

    constructor() {
        const canHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
        if (canHover) {
            const customCursor = document.getElementById('custom-cursor');
            const throttledWrite = this.throttle(requestAnimationFrame);
            this.getHoverContainers();

            htmx.on('htmx:afterSwap', () => {
                this.getHoverContainers();
                customCursor.classList.remove('has-hover');
            });

            htmx.on('htmx:historyRestore', () => {
                this.getHoverContainers();
            });

            const updateCursorPosition = (event) => {
                if (customCursor) {
                    customCursor.style.top = `${event.clientY}px`;
                    customCursor.style.left = `${event.clientX}px`;
                }
            }

            window.addEventListener('mousemove', (event) => {
                throttledWrite(() => {
                    let hoverCount = 0;
                    let cursorClass = null
                    this.hoverContainers.forEach(item => {
                        if (item.closest('.is-overflow')) {
                            if (item.matches(':hover')) {
                                updateCursorPosition(event);
                                cursorClass = item.dataset.cursor ?? null;
                                hoverCount++;
                            }
                        }
                    });
                    if (hoverCount > 0) {
                        customCursor.classList.add('has-hover');
                        customCursor.classList.add(cursorClass);
                    } else {
                        customCursor.classList.remove('has-hover');
                    }
                });
            }, {passive: true});
        }
    }

    getHoverContainers() {
        this.hoverContainers = document.querySelectorAll('[data-cursor]');
    }

    throttle (timer) {
        let queuedCallback
        return callback => {
            if (!queuedCallback) {
                timer(() => {
                    const cb = queuedCallback
                    queuedCallback = null
                    cb()
                })
            }
            queuedCallback = callback
        }
    }
}

export default CustomCursor;